import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OwnerCo } from '@model/syndic/owner-co';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmitterService } from '@service/emitter/emitter.service';
import { OwnerCoService } from '@service/syndic/owner-co.service';
import { SyndicService } from '@service/syndic/syndic.service';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-owner-co-add',
  templateUrl: './owner-co-add.component.html',
  styleUrls: ['./owner-co-add.component.scss']
})
export class OwnerCoAddComponent implements OnInit {

  form: FormGroup;
  submit: boolean = false;
  edit: boolean = false;
  ownerCo: OwnerCo;
  title: string = '';

  types = [
    { label: 'Personne physique', value: 'PERSONNE_PHYSIQUE' },
    { label: 'Personne morale', value: 'PERSONNE_MORALE' }
  ];

  civilites = [
    { label: 'M.', value: 'M' },
    { label: 'Mme', value: 'MME' },
    { label: 'Société', value: 'SOCIETE' }
  ];

  etats = [
    { label: 'Actif', value: 'ACTIF' },
    { label: 'Inactif', value: 'INACTIF' }
  ];

  constructor(
    public toastr: ToastrService,
    public modal: NgbActiveModal,
    private formBuild: FormBuilder,
    private emitter: EmitterService,
    private ownerCoService: OwnerCoService,
    private syndicService: SyndicService
  ) {
    this.edit = this.ownerCoService.edit;
    this.ownerCo = this.ownerCoService.getOwnerCo();
    const nom = this.ownerCo ? this.ownerCo.nomComplet : '';
    this.title = (!this.edit) ? 'Ajouter un copropriétaire' : 'Modifier le copropriétaire ' + nom;
  }

  ngOnInit(): void {
    this.createForm();
    if (this.edit && this.ownerCo) {
      this.setFormValue();
    }
  }

  createForm(): void {
    this.form = this.formBuild.group({
      uuid: [null],
      type: ['PERSONNE_PHYSIQUE', [Validators.required]],
      civilite: [null],
      nom: [null, [Validators.required]],
      prenom: [null],
      email: [null, [Validators.email]],
      telephone: [null],
      adresse: [null],
      etat: ['ACTIF'],
      raisonSociale: [null],
      representantLegal: [null],
      naturePiece: [null],
      numPiece: [null],
      trustee: [this.syndicService.getSyndic()?.uuid, [Validators.required]],
      houseCo: [null]
    });
  }

  setFormValue(): void {
    this.form.patchValue({
      uuid: this.ownerCo.uuid,
      type: this.ownerCo.type,
      civilite: this.ownerCo.civilite,
      nom: this.ownerCo.nom,
      prenom: this.ownerCo.prenom,
      email: this.ownerCo.email,
      telephone: this.ownerCo.telephone,
      adresse: this.ownerCo.adresse,
      etat: this.ownerCo.etat,
      raisonSociale: this.ownerCo.raisonSociale,
      representantLegal: this.ownerCo.representantLegal,
      naturePiece: this.ownerCo.naturePiece,
      numPiece: this.ownerCo.numPiece,
      trustee: this.ownerCo.trustee?.uuid,
      houseCo: this.ownerCo.houseCo?.uuid
    });
  }

  onSubmit(): void {
    this.submit = true;
    if (this.form.valid) {
      const data = this.form.getRawValue();
      this.ownerCoService.add(data).subscribe(
        (res: any) => {
          if (res?.status === 'success') {
            this.modal.close('ferme');
            if (this.edit) {
              this.emitter.event.emit({ action: 'OWNERCO_UPDATED', payload: res?.data });
            } else {
              this.emitter.event.emit({ action: 'OWNERCO_ADD', payload: res?.data });
            }
            Swal.fire({ icon: 'success', title: 'Succès', text: res?.message });
          }
        },
        (error: any) => {
          const msg = error?.error?.message || 'Une erreur est survenue';
          Swal.fire({ icon: 'error', title: 'Erreur', text: msg });
        }
      );
    }
  }

  onClose(): void {
    this.modal.close('ferme');
  }

  get f() { return this.form.controls; }
}
